/* Matmuis header – gedrag (okt 2026) */
(function () {

  /* ---------- Aanpassingen 10 okt 2026 ----------
     1. Mobiel menu als zijpaneel (max. 80% breed), pagina blijft rechts zichtbaar; tik op de laag = sluiten.
     2. Hoofdscherm menu: logo links, winkelwagen + sluiten rechts.
     3. Chatknop verborgen zolang het menu open is (Shopify Inbox).
     4. Muismatten-scherm: themategels eerst (+ tegel 'Alle thema's'), daaronder één lijst 'Soort muismat'.
     5. Reviewwidget (WebwinkelKeur) op de hele site: korte versie en altijd over de volle breedte van de inhoud. */
  var MMH_LIST_TITLE = 'Soort muismat';
  var MMH_ALL_TILE = 'Alle thema\u2019s';

  /* De widget kent alleen een vaste breedte in px. We meten de ruimte eromheen en bouwen de widget
     opnieuw op met die breedte en height="short". Bij een flinke wijziging van de schermbreedte opnieuw. */
  function mmhReviewWidth(w) {
    var p = w.parentElement;
    if (!p) return 0;
    var cs = window.getComputedStyle(p);
    return Math.floor(p.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0));
  }
  function mmhFixReviews() {
    document.querySelectorAll('valued-widget[layout="reviews"]').forEach(function (w) {
      var px = mmhReviewWidth(w);
      var cur = parseInt(w.getAttribute('width'), 10) || 0;
      if (w.getAttribute('height') === 'short' && px > 0 && Math.abs(cur - px) < 40) return;
      var c = document.createElement('valued-widget');
      Array.prototype.forEach.call(w.attributes, function (a) { c.setAttribute(a.name, a.value); });
      c.setAttribute('height', 'short');
      if (px > 0) c.setAttribute('width', px + 'px');
      c.style.display = 'block';
      c.style.maxWidth = '100%';
      w.replaceWith(c);
    });
  }
  var mmhResizeT = null, mmhLastW = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(mmhResizeT);
    mmhResizeT = setTimeout(function () {
      if (Math.abs(window.innerWidth - mmhLastW) < 40) return;
      mmhLastW = window.innerWidth;
      mmhFixReviews();
    }, 400);
  });

  function mmhPanelStyles() {
    if (document.getElementById('mmh-drawer-panel-css')) return;
    var css =
      '.mmh-drawer{background:rgba(32,32,32,.45) !important;z-index:2147483000 !important;}' +
      '.mmh-drawer .mmh-screen{right:auto;width:min(80vw,360px);box-shadow:8px 0 32px rgba(0,0,0,.2);}' +
      '.mmh-drawer.is-opening{animation:mmhFade .25s ease;}' +
      '.mmh-drawer.is-opening .mmh-screen{animation:mmhSlide .25s ease;}' +
      '@keyframes mmhFade{from{background:rgba(32,32,32,0)}to{background:rgba(32,32,32,.45)}}' +
      '@keyframes mmhSlide{from{transform:translateX(-100%)}to{transform:translateX(0)}}' +
      '@media (prefers-reduced-motion:reduce){.mmh-drawer.is-opening,.mmh-drawer.is-opening .mmh-screen{animation:none;}}' +
      '[data-mmh-screen="main"]>.mmh-dhead{padding-left:16px;}' +
      '[data-mmh-screen="main"]>.mmh-dhead>.mmh-logo{order:1;}' +
      '[data-mmh-screen="main"]>.mmh-dhead>[data-mmh-cart]{order:2;margin-left:auto;}' +
      '[data-mmh-screen="main"]>.mmh-dhead>[data-mmh-close-drawer]{order:3;}' +
      'html.mmh-menu-open #shopify-chat,html.mmh-menu-open inbox-online-store-chat{display:none !important;}' +
      '.mmh-msec{padding:4px 16px 0;}' +
      '.mmh-msec__head{padding:14px 0 10px;}' +
      '.mmh-msec__title{font-size:17px;font-weight:700;color:var(--mmh-navy);}' +
      '.mmh-msec .mmh-tiles--m{padding-top:0;}' +
      '.mmh-tile--all .mmh-tile__img{background:var(--mmh-navy,#00296b);color:#fff;display:flex;align-items:center;justify-content:center;transition:background .2s ease;}' +
      '.mmh-tile--all:hover .mmh-tile__img{background:#0d3c8f;}' +
      '.mmh-drawer .mmh-tile--all{color:var(--mmh-navy,#00296b);}' +
      '.mmh-msec__list{display:flex;flex-direction:column;border-top:1px solid #eef0f3;}' +
      '.mmh-msec__list a{font-size:15px;padding:13px 0;border-bottom:1px solid #eef0f3;}';
    var st = document.createElement('style');
    st.id = 'mmh-drawer-panel-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function mk(tag, cls) { var el = document.createElement(tag); el.className = cls; return el; }
  function mmhSection(title) {
    var sec = mk('div', 'mmh-msec');
    var head = mk('div', 'mmh-msec__head');
    var t = mk('span', 'mmh-msec__title');
    t.textContent = title;
    head.appendChild(t);
    sec.appendChild(head);
    return sec;
  }
  function mmhRestructure(drawer, allHref) {
    drawer.querySelectorAll('[data-mmh-screen]').forEach(function (screen) {
      var acc = screen.querySelector('.mmh-acc');
      if (!acc || acc.dataset.mmhDone) return;
      var tileDet = null;
      acc.querySelectorAll('details').forEach(function (d) { if (!tileDet && d.querySelector('.mmh-tiles--m')) tileDet = d; });
      if (!tileDet) return;
      acc.dataset.mmhDone = '1';
      var sum = tileDet.querySelector('summary');
      var tilesSec = mmhSection(sum ? sum.textContent.trim() : 'Shop op thema');
      var grid = tileDet.querySelector('.mmh-tiles--m');
      tilesSec.appendChild(grid);
      var viewall = screen.querySelector('.mmh-viewall');
      var href = allHref || (viewall ? viewall.getAttribute('href') : '');
      if (href) {
        var all = mk('a', 'mmh-tile mmh-tile--all');
        all.href = href;
        all.innerHTML = '<span class="mmh-tile__img"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
        all.appendChild(document.createTextNode(MMH_ALL_TILE));
        grid.appendChild(all);
      }
      var seen = {};
      if (viewall) seen[viewall.getAttribute('href')] = true;
      var links = [];
      Array.prototype.forEach.call(acc.children, function (ch) {
        if (ch === tileDet) return;
        var found = ch.matches('a') ? [ch] : Array.prototype.slice.call(ch.querySelectorAll('.mmh-acc__list a'));
        found.forEach(function (a) {
          var h = a.getAttribute('href');
          if (seen[h]) return;
          seen[h] = true;
          a.className = '';
          links.push(a);
        });
      });
      var frag = document.createDocumentFragment();
      frag.appendChild(tilesSec);
      if (links.length) {
        var listSec = mmhSection(MMH_LIST_TITLE);
        var list = mk('div', 'mmh-msec__list');
        links.forEach(function (a) { list.appendChild(a); });
        listSec.appendChild(list);
        frag.appendChild(listSec);
      }
      acc.parentNode.insertBefore(frag, acc);
      acc.remove();
    });
  }

  function mmhInit() {
    mmhFixReviews();
    var root = document.querySelector('[data-mmh]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    mmhPanelStyles();

    var items = root.querySelectorAll('[data-mmh-item]');
    var openTimer = null, closeTimer = null, current = null;
    var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

    function setOpen(item, state) {
      var panel = document.getElementById(item.dataset.mmhItem);
      var btn = item.querySelector('[data-mmh-toggle]');
      if (!panel) return;
      panel.hidden = !state;
      item.classList.toggle('is-open', state);
      if (btn) btn.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
    function openItem(item) {
      clearTimeout(closeTimer);
      if (current && current !== item) setOpen(current, false);
      setOpen(item, true);
      current = item;
      root.classList.add('has-panel-open');
    }
    function closeAll() {
      clearTimeout(openTimer);
      if (current) setOpen(current, false);
      current = null;
      root.classList.remove('has-panel-open');
    }
    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 220);
    }

    items.forEach(function (item) {
      var panel = document.getElementById(item.dataset.mmhItem);
      item.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openItem(item); }, current ? 0 : 250);
      });
      item.addEventListener('mouseleave', function () { if (canHover.matches) scheduleClose(); });
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', function () { if (canHover.matches) scheduleClose(); });
      }
      var btn = item.querySelector('[data-mmh-toggle]');
      if (btn) btn.addEventListener('click', function () {
        if (current === item) { closeAll(); } else { openItem(item); }
      });
    });
    var backdrop = root.querySelector('[data-mmh-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeDrawer(); }
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        root.classList.toggle('mmh--scrolled', window.scrollY > 60);
        ticking = false;
      });
    }, { passive: true });

    var drawer = root.querySelector('[data-mmh-drawer]');
    var opener = root.querySelector('[data-mmh-open-drawer]');
    var oldDrawer = document.body.querySelector(':scope > [data-mmh-drawer]');
    if (oldDrawer && oldDrawer !== drawer) oldDrawer.remove();
    if (drawer) document.body.appendChild(drawer);
    var themesAll = root.querySelector('.mmh-tiles__all');
    if (drawer) mmhRestructure(drawer, themesAll ? themesAll.getAttribute('href') : '');
    var openingTimer = null;
    function show(name) {
      drawer.querySelectorAll('[data-mmh-screen]').forEach(function (s) {
        s.hidden = s.dataset.mmhScreen !== name;
      });
    }
    function openDrawer() {
      show('main');
      drawer.classList.add('is-opening');
      clearTimeout(openingTimer);
      openingTimer = setTimeout(function () { drawer.classList.remove('is-opening'); }, 300);
      drawer.hidden = false;
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('mmh-menu-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('[data-mmh-close-drawer]');
      if (first) first.focus();
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('mmh-menu-open');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    }
    if (opener) opener.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-mmh-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.querySelectorAll('[data-mmh-go]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.mmhGo); });
    });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });

    var cartLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mmh-cart]')).concat(Array.prototype.slice.call(drawer.querySelectorAll('[data-mmh-cart]')));
    cartLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (!cd || typeof cd.open !== 'function') return;
        e.preventDefault();
        closeDrawer();
        cd.open(a);
      });
    });
    function fmt(cents, currency) {
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100).replace(/\s/g, '');
      } catch (err) { return (cents / 100).toFixed(2); }
    }
    function refreshCart() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          root.querySelectorAll('[data-mmh-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.dataset.count = c.item_count; });
          root.querySelectorAll('[data-mmh-cart-total]').forEach(function (el) { el.textContent = fmt(c.total_price, c.currency); });
        })
        .catch(function () {});
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && 'MutationObserver' in window) {
      new MutationObserver(refreshCart).observe(bubble, { childList: true, subtree: true });
    }
    document.addEventListener('cart:updated', refreshCart);
  }
  mmhInit();
  document.addEventListener('shopify:section:load', mmhInit);
})();